import React from "react";
import { Download } from "lucide-react";

// Compact, brand-consistent export button. Rounded pill styling matching the
// new visual system — teal→violet gradient for primary, soft grey for default.
export const ExportButton = ({ label = "Export CSV", onClick, testId, variant = "default", disabled }) => {
  const primary = variant === "primary";
  const style = primary
    ? {
        color: "#FFFFFF",
        background: "linear-gradient(135deg, #00B4D8 0%, #7C6FF0 100%)",
        boxShadow: "0 4px 12px rgba(0,180,216,0.28)",
      }
    : {
        color: "#14142B",
        background: "#FFFFFF",
        boxShadow: "0 1px 2px rgba(20,20,43,0.05), inset 0 0 0 1px #E1E5EE",
      };
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full text-[10px] uppercase tracking-widest font-bold px-3 py-1.5 transition-all disabled:opacity-50 disabled:cursor-not-allowed ${
        primary ? "hover:brightness-110 hover:scale-[1.03]" : "hover:bg-[#F5F6FA]"
      }`}
      style={style}
      title={label}
    >
      <Download size={12} strokeWidth={2.2} />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
};

export default ExportButton;
